
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { EpbText } from '../../shared/epb-text'

export default defineComponent({
  name: 'InsightCard',
  components: {
    EpbText,
  },
  props: {
    value: {
      type: [Number, String] as PropType<number | string | null>,
      default: undefined,
    },
    label: {
      type: String as PropType<string>,
      required: true,
    },
    description: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup() {
    const baseClass = 'epb-insight-card'
    return {
      baseClass,
    }
  },
})
